import { callAPI, chameau, GATEWAY_PROXY, METHODS } from "utils/apiUtils";
import store from "../store";
import CakeStore from "assets/js/store";
import { setUserBrandSDK } from "assets/js/data/userBrandSDK/actions";

export const getBrandService = (
	successCallback = () => { },
	failureCallback = () => { }
) => {
	callAPI(
		{
			url: GATEWAY_PROXY + `/brands/compiledBrand.json`,
			method: METHODS.get,
		},
		successCallback,
		failureCallback
	);
};

export const updateBrandService = (
	options = { brand: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	callAPI(
		{
			url: GATEWAY_PROXY + "/brands/brand.json",
			method: METHODS.put,
			body: options,
		},
		successCallback,
		failureCallback
	);
};

export const getUserBrandService = (
	options = { id: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	let accountId = options.id ? options.id : store.getState().global.account.id;
	callAPI(
		{
			url: GATEWAY_PROXY + `/brands/${accountId}/brand.json`,
			method: METHODS.get,
		},
		successCallback,
		failureCallback
	);
};

export const updateUserBrandService = (
	options = { brand: "", id: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	let accountId = options.id ? options.id : store.getState().global.account.id;
	callAPI(
		{
			url: GATEWAY_PROXY + `/brands/${accountId}/brand.json`,
			method: METHODS.put,
			body: options.brand,
		},
		successCallback,
		failureCallback
	);
};

export const createBrandService = (
	options = { brand: {}, id: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	let accountId = options.id ? options.id : store.getState().global.account.id;
	callAPI(
		{
			url: GATEWAY_PROXY + `/brands/${accountId}/brand.json`,
			method: METHODS.post,
			body: options.brand,
		},
		successCallback,
		failureCallback
	);
};

export const getUserBrandSDK = (
	options = { url: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	callAPI(
		{
			url: options.url,
			method: METHODS.get,
		},
		(data) => {
			CakeStore.dispatch(setUserBrandSDK(data));
			successCallback(data);
		},
		failureCallback
	);
};

export const uploadBrandLogoService = (
	options = { file: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	callAPI(
		{
			url: GATEWAY_PROXY + "/brands/default/logos/default",
			method: METHODS.put,
			body: { file: options.file },
			query: { account_id: store.getState().global.account.id },
		},
		successCallback,
		failureCallback
	);
};

export const deleteLogoService = (
	successCallback = () => { },
	failureCallback = () => { }
) => {
	callAPI(
		{
			url: GATEWAY_PROXY + "/brands/default/logos/default",
			method: METHODS.delete,
			query: { account_id: store.getState().global.account.id },
		},
		successCallback,
		failureCallback
	);
};

export const updateUserBrandConfig = (
	options = { accountId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	callAPI(
		{
			url: GATEWAY_PROXY + `/brands/${options.accountId}/config`,
			method: METHODS.put,
			query: { account_id: store.getState().global.account.id },
		},
		successCallback,
		failureCallback
	);
};

export const getUserCompiledBrand = (
	options = { accountId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	callAPI(
		{
			url: GATEWAY_PROXY + `/brands/${options.accountId}/compiledBrand.json`,
			method: METHODS.get,
			query: { account_id: store.getState().global.account.id },
		},
		successCallback,
		failureCallback
	);
};
